"use strict"; //BANKRUPTCY

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_LOANS_MOTION_TO_REOPEN = exports.STUDENT_LOANS_SUMMONS = exports.STUDENT_LOANS_ATTESTATION = exports.STUDENT_LOANS_ADVERSARY_PROCEEDING_COVER_SHEET = exports.STUDENT_LOANS_UPSOLVE_BANKRUPTCY_OPEN = exports.STUDENT_LOANS_UPSOLVE_BANKRUPTCY_REOPENING = exports.STUDENT_LOANS_COMBINED_FILING = exports.FORM_G_1145 = exports.FORM_G_1450 = exports.FORM_I_765 = exports.PACKET_DRAFT = exports.PACKET_TRUSTEE = exports.PACKET_FILING = exports.AMENDMENT = exports.LOCAL_FORMS = exports.SUPPORT_DOCUMENTS = exports.PAY_ADVICES = exports.FORM_122_A = exports.FORM_121 = exports.FORM_108 = exports.FORM_107 = exports.CREDITOR_MATRIX = exports.FORM_106_DEC = exports.FORM_106_SUM = exports.FORM_106_J = exports.ADD_EMPLOYMENT_BUSINESS = exports.FORM_106_I = exports.FORM_106_H = exports.FORM_106_G = exports.FORM_106_EF = exports.FORM_106_D = exports.FORM_106_C = exports.FORM_106_AB = exports.FORM_103 = exports.FORM_101_A = exports.FORM_101 = exports.PETITION = exports.CRIMINAL_DISPOSITION = exports.UTILITY = exports.TAX_RETURN_REQUEST = exports.TAX_RETURN = exports.PAY_STUB = exports.PAY_DAY_LOAN = exports.MEDICAL_RECORD = exports.JUDGMENT = exports.ESIGN = exports.CREDIT_REPORT = exports.CERTIFICATE_OF_COUNSELING = exports.CERTIFICATE_OF_COMPLETION = exports.ADDITION = void 0;
exports.STUDENT_LOANS_COMPLAINT = void 0; // Supplements/Uploads

exports.ADDITION = "addition";
exports.CERTIFICATE_OF_COMPLETION = "certificateOfCompletion";
exports.CERTIFICATE_OF_COUNSELING = "certificateOfCounseling";
exports.CREDIT_REPORT = "creditReport";
exports.ESIGN = "esign";
exports.JUDGMENT = "judgment";
exports.MEDICAL_RECORD = "medicalRecord";
exports.PAY_DAY_LOAN = "payDayLoan";
exports.PAY_STUB = "payStub";
exports.TAX_RETURN = "taxReturn";
exports.TAX_RETURN_REQUEST = "taxReturnRequest";
exports.UTILITY = "utility";
exports.CRIMINAL_DISPOSITION = "criminalDisposition"; // Docassemble

exports.PETITION = "petition"; // Deprecate
// Forms/Sections

exports.FORM_101 = "form101";
exports.FORM_101_A = "form101A";
exports.FORM_103 = "form103";
exports.FORM_106_AB = "form106AB";
exports.FORM_106_C = "form106C";
exports.FORM_106_D = "form106D";
exports.FORM_106_EF = "form106EF";
exports.FORM_106_G = "form106G";
exports.FORM_106_H = "form106H";
exports.FORM_106_I = "form106I";
exports.ADD_EMPLOYMENT_BUSINESS = "addEmploymentBusiness";
exports.FORM_106_J = "form106J";
exports.FORM_106_SUM = "form106Sum";
exports.FORM_106_DEC = "form106Dec";
exports.CREDITOR_MATRIX = "creditorMatrix";
exports.FORM_107 = "form107";
exports.FORM_108 = "form108";
exports.FORM_121 = "form121";
exports.FORM_122_A = "form122A";
exports.PAY_ADVICES = "payAdvices";
exports.SUPPORT_DOCUMENTS = "supportDocuments";
exports.LOCAL_FORMS = "localForms"; // Compilations

exports.AMENDMENT = "amendment";
exports.PACKET_FILING = "packetFiling";
exports.PACKET_TRUSTEE = "packetTrustee";
exports.PACKET_DRAFT = "packetDraft"; //IMMIGRATION
// Work Permit

exports.FORM_I_765 = "formI765"; // Payment

exports.FORM_G_1450 = "formG1450"; // USCIS Notice

exports.FORM_G_1145 = "formG1145"; //STUDENT LOANS
//TODO: rethink this. packet types shouldnot be stored in this document types file. See this ticket: https://www.notion.so/upsolve/Move-packetTypes-out-of-document-types-in-shared-package-fe82c2347c9544e897773f5165436a83?pvs=4

exports.STUDENT_LOANS_COMBINED_FILING = "studentLoansCombinedFiling";
exports.STUDENT_LOANS_UPSOLVE_BANKRUPTCY_REOPENING = "studentLoansUpsolveBankruptcyReopening";
exports.STUDENT_LOANS_UPSOLVE_BANKRUPTCY_OPEN = "studentLoansUpsolveBankruptcyOpen";
exports.STUDENT_LOANS_ADVERSARY_PROCEEDING_COVER_SHEET = "adversaryProceedingCoverSheet";
exports.STUDENT_LOANS_ATTESTATION = "studentLoansAttestation"; //we will probably attach the service list to the summons

exports.STUDENT_LOANS_SUMMONS = "studentLoansSummons";
exports.STUDENT_LOANS_MOTION_TO_REOPEN = "studentLoansMotionToReopen";
exports.STUDENT_LOANS_COMPLAINT = "studentLoansComplaint";